import { Component, Input, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

export interface FooterLink {
  label: string;
  path: string;
}

import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-footer',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './footer.html',
  styleUrl: './footer.css',
  encapsulation: ViewEncapsulation.None
})
export class FooterComponent {
  @Input() contactTitle: string = 'Get In Touch';
  @Input() address: string = 'Sidney, Australia';
  @Input() email: string = 'wescotcorporation@wescot.com.co';
  @Input() phone: string = '+00 61 426 037 898';

  @Input() col2Title: string = 'Quick Links';
  @Input() col2Links: FooterLink[] = [];

  @Input() col3Title: string = 'Popular Links';
  @Input() col3Links: FooterLink[] = [];

  @Input() newsletterTitle: string = 'Noticias';
  @Input() newsletterSubtitle: string = 'Subscríbete';
  @Input() newsletterPlaceholder: string = 'Your Email';
  @Input() newsletterButton: string = 'Sign Up';

  @Input() copyrightText: string = 'Wescot Corp';
  @Input() privacyPolicyText: string = 'Privacy Policy';
  @Input() privacyPolicyPath: string = '/privacy-policy';
  @Input() showPrivacyPolicy: boolean = true;

  currentYear: number = new Date().getFullYear();

  onSubscribe(event: Event) {
    event.preventDefault();
    console.log('Subscribe form submitted (static only)');
    // alert('Subscription simulated.'); // Avoiding alert in production code usually, but okay for migration demo if needed.
  }
}
